import React from 'react';
import { useTranslation } from 'react-i18next';
import { History as HistoryIcon } from '@material-ui/icons';
import { ActionIconButton } from '../../../../common-client2/src/components'

const ViewHistoryButton = ({
    onClick
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'manager.actions' })

    return (
        <div className="table--actions-container">
            <ActionIconButton
                className="view-history-button"
                title={t('viewHistory')}
                onClick={onClick}
            >
                <HistoryIcon className="view-history-icon" />
            </ActionIconButton>
        </div>
    )
};

export default ViewHistoryButton;